export const baseUrl = "https://webexapis.com";
// + localStorage.getItem('WebexAcessToken')
// || "Bearer ZDgyYmJkZWUtNGM4Zi00NWMyLTliMTEtNmRjZjIyOTUyNjNlYWQ2MWI5ZTAtZjk0_PF84_d0f52143-60a8-4be7-99ce-035672a03f2b"
export var getHeaders = () => {
  var webexTokeen = "Bearer " + localStorage.getItem('WebexAcessToken') 
  var headers = new Headers();
  headers.append("Authorization", webexTokeen);
  headers.append("Content-Type", "application/json");
  return headers
}